export var defaultProps = {
    className: '',
    triggerEvent: 'click',
    title: '',
    defaultVisible: false,
    placement: 'Top',
    overlayClassName: '',
    backgroundColor: 'rgba(255,255,255,1)',
    okText: '',
    icon: '',
    cancelText: '',
    disabled: false,
    async: false,
    visible: false,
};
